import { type ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from './useAuth';

/**
 * Gate that wraps every non-public route. Redirects unauthenticated users to
 * `/login?next=<current-path>` so they bounce back here after Hosted UI.
 *
 * In fake-mode the AuthProvider resolves immediately to FAKE_CLAIMS, so this
 * is effectively a no-op for the dev experience.
 */
export function RequireAuth({ children }: { children: ReactNode }) {
  const { status } = useAuth();
  const location = useLocation();

  if (status === 'loading') {
    // Render nothing while the OIDC library decides. A spinner would be nice
    // but would flash in fake-mode where this resolves on the next tick.
    return null;
  }
  if (status === 'anonymous' || status === 'error') {
    const next = encodeURIComponent(location.pathname + location.search);
    return <Navigate to={`/login?next=${next}`} replace />;
  }
  return <>{children}</>;
}
